<template>
  <div class="item">
    <div class="mainItemInfo">
      <div class="price">
        <p>{{ item.price.toFixed(2) }} €</p>
      </div>
      <div class="itemTitle">
        <a :href="'/categories/' + item.category.id + '/items/' + item.id">{{ item.title }}</a>
      </div>
    </div>
    <div class="itemBottom">
      <a>Paskelbė: {{ item.account.name + " " + item.account.last_name }}</a>
      <div class="commentCount" :href="'/categories/' + item.category.id + '/items/' + item.id">
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd"
          viewBox="0 0 512 450.27">
          <path
            d="M217.91 393.59c53.26 49.01 127.33 63.27 201.39 31.71l63.49 24.97-9.94-59.73c59.07-51.65 45.36-123.42-1.79-173.93-3.69 19.53-10.48 38.07-19.94 55.27-14.17 25.77-34.46 48.67-59.31 67.52-24.07 18.27-52.17 32.61-82.8 41.87-28.16 8.51-58.91 12.91-91.1 12.32zm-85.88-167.22c-7.7 0-13.95-6.25-13.95-13.95 0-7.7 6.25-13.95 13.95-13.95h124.12c7.7 0 13.94 6.25 13.94 13.95 0 7.7-6.24 13.95-13.94 13.95H132.03zm0-71.41c-7.7 0-13.95-6.25-13.95-13.95 0-7.71 6.25-13.95 13.95-13.95h177.35c7.7 0 13.94 6.24 13.94 13.95 0 7.7-6.24 13.95-13.94 13.95H132.03zM226.13.12l.21.01c60.33 1.82 114.45 23.27 153.19 56.49 39.57 33.92 63.3 80.1 61.82 130.51l-.01.23c-1.56 50.44-28.05 95.17-69.62 126.71-40.74 30.92-96.12 49.16-156.44 47.39-15.45-.46-30.47-2.04-44.79-4.82-12.45-2.42-24.5-5.75-36-10.05L28.17 379.06l31.85-75.75c-18.2-15.99-32.94-34.6-43.24-55.01C5.29 225.51-.72 200.48.07 174.33c1.52-50.49 28.02-95.26 69.61-126.82C110.44 16.59 165.81-1.65 226.13.12zm-.55 27.7-.21-.01C171.49 26.23 122.33 42.3 86.41 69.55c-35.07 26.61-57.39 63.9-58.65 105.54-.65 21.39 4.31 41.94 13.78 60.72 10.01 19.82 25.02 37.7 43.79 52.58l8.26 6.54-16.99 40.39 59.12-18.06 4.5 1.81c11.15 4.48 23.04 7.9 35.48 10.31 13.07 2.55 26.59 3.98 40.34 4.39 53.88 1.58 103.04-14.49 138.96-41.74 35.07-26.61 57.39-63.9 58.65-105.54v-.22c1.19-41.57-18.82-80.01-52.15-108.59-34.18-29.3-82.19-48.24-135.92-49.86z" />
        </svg>
        <p>{{ item.commentCount }}</p>
      </div>
      <p>{{ item.state.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>

<style>
.item {
  text-align: left;
  max-width: 500px;
  background-color: #91a1a1;
  margin: auto;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
}

.itemTitle a {
  padding: 0;
  margin: 0;
  color: rgb(42, 70, 68);
}

.price {
  float: right;
}

.mainItemInfo {
  margin-bottom: 20px;
}

.itemBottom {
  font-size: 0.8em;
}

.commentCount {
  height: 30px;
  float: right;
  display: flex;
}

.commentCount>svg {
  margin: auto;
}

.commentCount>p {
  margin: auto;
  margin-left: 5px;
  font-size: 1.2em;
}
</style>